import { Box } from '@mui/system';
import { FC } from 'react';
import { UploadImage } from '../../../../components/common/avatars/UploadImage';
import { AvatarWithIndication } from '../../../../components/common/avatars/AvatarWithIndication';
import { VIEW_MODE } from '../../../../consts/enums';

export const style = {
  boxRow: {
    display: 'flex',
    marginBottom: '10px',
    alignItems: 'center',
  },
  boxUploadWrapper: {
    width: 66,
    height: 'auto',
    mr: 2,
  },
} as const;

type institutionRowProps = {
  logo: string,
  children: React.ReactChild,
  onChangeImage: (e: React.ChangeEvent<HTMLInputElement>) => void,
  isloading: boolean,
  canUploadImage: boolean,
  disabled: boolean,
  FallBack: FC<{width:string, height:string}>,
  viewMode: ViewMode
}

export const InstitutionRow = ({
  logo,
  children,
  onChangeImage,
  isloading,
  canUploadImage,
  disabled,
  FallBack,
  viewMode,
}: institutionRowProps): JSX.Element => {
  const isReadMode = viewMode === VIEW_MODE.READ_ONLY;

  const defineAvatar = () => {
    return (
      canUploadImage ?
        (
          <UploadImage
            isDisabled={ disabled }
            isLoading={ isloading }
            handleInputUploadImage={ onChangeImage }
            alt={ logo }
            profileImage={ logo }
          />
        ) : (
          <AvatarWithIndication
            alt={ logo }
            src={ logo }
          />
        )
    );
  };

  return (
    <>
      <Box style={ style.boxRow }>
        <Box sx={ style.boxUploadWrapper }>
          {(disabled || isReadMode) && !logo ? <FallBack width="56px" height="56px" /> :
            defineAvatar()}
        </Box>
        { children }
      </Box>
    </>
  );
};
